import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DividerModule } from '../divider/divider.module';
import { IconModule } from '../icon/icon.module';
import { AvatarModule } from '../avatar/avatar.module';

import { ListModule } from '../list/list.module';
import { ListContentModule } from '../list/list-content.module';
import { ListTitleModule } from '../list/list-title.module';
import { ListDescriptionModule } from '../list/list-description.module';
import { ListActionsModule } from '../list/list-actions.module';

import { MenuItemComponent } from './menu-item.component';

@NgModule({
  declarations: [MenuItemComponent],
  imports: [
    CommonModule,
    ListModule,
    ListContentModule,
    ListTitleModule,
    ListDescriptionModule,
    ListActionsModule,
    IconModule,
    DividerModule,
    AvatarModule
  ],
  exports: [MenuItemComponent],
})
export class MenuItemModule {}
